export default __webpack_public_path__ + "static/media/appstore.f86f78ae.png";